import Component, { OfferCardData } from './OfferCard';

export {
  OfferCardData
};

export default Component;
